import styled from 'styled-components'
import TextAnt from 'antd/lib/typography/Text'

export const Button = styled.div`
  display: flex;
  justify-content: end;
`

export const Content = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 35px;
`

export const Div = styled.div`
  margin-top: 20px;
`

export const Text = styled(TextAnt)`
  font-weight: bold;
`
